import {
  Box,
  Button,
  EllipsisMenu,
  SearchInput,
  useRect,
  useWindowSize
} from '@platform/ui-library';
import {
  CSSProperties,
  FC,
  useState
} from 'react';
import { useCustomNavigate } from '../../hooks';
import { Design } from '../../types';
import { createIntentCsvConfig, downloadFile } from '../../utilities';
import styles from '../modals/IntentDetails.module.scss';
import { Table } from '../table';

interface ListIntentProps {
  serialized: Design;
}

export const ListIntents: FC<ListIntentProps> = ({
  serialized
}) => {
  const [designIntentTableSearch, setDesignIntentTableSearch] = useState<string>('');
  const navigate = useCustomNavigate();
  const [ref, refRect] = useRect();
  const [_, windowHeight] = useWindowSize();

  const containerStyle: CSSProperties = {
    maxHeight: (windowHeight - refRect.top - 20) + 'px'
  };

  return (
    <div ref={ref} className={styles.listIntentsContainer} style={containerStyle}>
      <Box className={`${styles.box} ${styles.listIntentsWidth}`} theme={'noPadding'}>
        <div className={`${styles.header} ${styles.listHeaderFlex}`}>
          <h2 className={`${styles.title} ${styles.withIcon}`}>
            Intents
          </h2>
          <div className={`${styles.listMenusFlex}`}>
            <SearchInput
              name={'searchIntents'}
              placeholder={'Search Intents'}
              onChange={(inputValue) => {
                setDesignIntentTableSearch(inputValue);
              }}
              extraClasses={styles.input}
              value={designIntentTableSearch}
            />
            <Button
              icon='download'
              onClick={() => {
                downloadFile(createIntentCsvConfig({ serialized }));
              }}
              theme='outline'
            />
            <EllipsisMenu
              items={[
                {
                  action: () => {
                    navigate('import');
                  },
                  label: 'Import from Library'
                },
                {
                  action: () => {
                    navigate('create');
                  },
                  label: 'Create Custom Intent'
                },
                {
                  action: () => {
                    navigate('import-from-csv');
                  },
                  label: 'Import from CSV'
                }
              ]}
              theme={'outlineHighlight'}
              icon={'plus'}
              iconPosition={'left'}
              text={'Add Intent'}
            />
          </div>
        </div>
        <div className="box content flex-shrink">
          <Table
            className={styles.fullListTable}
            data={serialized.components.intents.map((designIntent) => {
              const { id, name } = designIntent;
              const { localeData, commonIntent } = designIntent.props.config;
              return {
                id: id,
                name,
                description: designIntent.props.config.description ?? '',
                utterances: localeData['en-US']?.phrases.length ?? 0,
                library: commonIntent?.name || 'None',
                '': (
                  <Button
                    key={id}
                    icon={'edit'}
                    type='button'
                    theme='outlineHighlight'
                    onClick={() => {
                      navigate(`edit/${id}`);
                    }}
                  ></Button>
                )
              };
            })}
            filter={designIntentTableSearch}
            filterByColumns={['name']}
            sortByColumns={['name']}
          />
        </div>
      </Box>
    </div>
  );
};
